import { text, title, Views } from './LoginForm.const';
import { Text, Title } from './LoginForm.styles';

const FormHeader = (props: { view: Views; confirmationMethod?: string; email?: string }) => {
  const { view, confirmationMethod, email = '' } = props;
  return (
    <>
      <Title>{title[view]}</Title>
      <Text>
        {view === Views.forgot_password_confirmed ? (
          <>{text[view].replace('{{email}}', email)}</>
        ) : (
          <>
            {text[view]}
            {view === Views.otp_code && confirmationMethod && (
              <>
                <br />
                <b>{confirmationMethod}</b>
              </>
            )}
          </>
        )}
      </Text>
    </>
  );
};

export default FormHeader;
